import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackground = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 524 280",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "Background_svg__b",
			width: 524,
			height: 525,
			x: 0,
			y: -194,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "url(#Background_svg__a)",
				d: "M0-193.5h524v524H0z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#E4E7EC",
			strokeWidth: .751,
			mask: "url(#Background_svg__b)",
			children: [
				/* @__PURE__ */ _jsx("circle", {
					cx: 260.953,
					cy: 67.453,
					r: 47.679
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 260.954,
					cy: 67.454,
					r: 83.72,
					opacity: .9
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 260.953,
					cy: 67.454,
					r: 119.761,
					opacity: .8
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 260.953,
					cy: 67.453,
					r: 155.801,
					opacity: .7
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 260.953,
					cy: 67.453,
					r: 191.842,
					opacity: .6
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 260.953,
					cy: 67.453,
					r: 227.883,
					opacity: .5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 260.953,
					cy: 67.453,
					r: 263.924,
					opacity: .4
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "Background_svg__a",
			x1: 262,
			x2: 262,
			y1: -193.5,
			y2: 330.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .437,
				stopColor: "#fff"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .662,
				stopColor: "#fff",
				stopOpacity: 0
			})]
		}) })
	]
});
export default SvgBackground;
